import defaultHeaderImg from '../../assets/images/default-header.png';
import Body from '../../components/GameTicket/GameTicket';
import { ActionType } from '../../enums';

import {
  TXTCLI_Close,
  TXTWCL_An_error_occurred_with_your_ac_ELL
} from './NotificationError.messages.json';

export default {
  front: {
    view: Body,
    viewConfig: {
      title: { tag: TXTWCL_An_error_occurred_with_your_ac_ELL },
      defaultHeaderImageURL: defaultHeaderImg,
      showCloseIcon: true,
      displayAttributes: [],
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: { tag: TXTCLI_Close }
        }
      ]
    }
  }
};
